import { useEffect, useState } from "react";
import { orderActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const usePinPurchaseOrder = () => {
    const dispatch = useAppDispatch();
    const [isPinning, setIsPinning] = useState(false);
    const [isUnpinning, setIsUnpinning] = useState(false);

    const { pinningPurchaseOrder, pinPurchaseOrderSuccess, pinPurchaseOrderFailure } =
        useAppSelector((state) => state.order);
    const { unpinningPurchaseOrder, unpinPurchaseOrderSuccess, unpinPurchaseOrderFailure } =
        useAppSelector((state) => state.order);

    const handlePin = (poId: string) => {
        setIsPinning(true);
        dispatch(orderActions.pinPurchaseOrder(poId));
    };

    const handleUnpin = (poId: string) => {
        setIsUnpinning(true);
        dispatch(orderActions.unpinPurchaseOrder(poId));
    };

    useEffect(() => {
        if (pinPurchaseOrderSuccess && isPinning) {
            setIsPinning(false);
            dispatch(orderActions.resetPinPurchaseOrderSuccess());
        }
    }, [pinPurchaseOrderSuccess, isPinning, dispatch]);

    useEffect(() => {
        if (pinPurchaseOrderFailure && isPinning) {
            setIsPinning(false);
        }
    }, [pinPurchaseOrderFailure, isPinning]);

    useEffect(() => {
        if (unpinPurchaseOrderSuccess && isUnpinning) {
            setIsUnpinning(false);
            dispatch(orderActions.resetUnpinPurchaseOrderSuccess());
        }
    }, [unpinPurchaseOrderSuccess, isUnpinning, dispatch]);

    useEffect(() => {
        if (unpinPurchaseOrderFailure && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [unpinPurchaseOrderFailure, isUnpinning]);

    return {
        isPinning: pinningPurchaseOrder || isPinning,
        isUnpinning: unpinningPurchaseOrder || isUnpinning,
        error: pinPurchaseOrderFailure || unpinPurchaseOrderFailure,
        success: pinPurchaseOrderSuccess || unpinPurchaseOrderSuccess,
        pinSuccess: pinPurchaseOrderSuccess,
        unpinSuccess: unpinPurchaseOrderSuccess,
        handlePin,
        handleUnpin,
    };
};

export default usePinPurchaseOrder;
